import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { HamburgerMenu,webStorage,pageTransition,wrapWordsInSpan,scrollHint } from "./lib/util";
import modalImage from './lib/modalImage.js';
import Smoother from './lib/smoother.js';
import ShaderCanvas from "./lib/effect.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('js-on');

  /*----------------------------------------
    loading
  ------------------------------------------*/
  webStorage('loading');
  pageTransition();
  wrapWordsInSpan('.is-split');
  
  /*----------------------------------------
    scroll smoothre
  ------------------------------------------*/
  const smooth = new Smoother({
    target  : '#smoother',
    headerId: 'hd-nav',
    scrub   : 1,
  });

  // header nav
  ScrollTrigger.create({
    trigger: '#mainimg',
    target: '#hd-nav',
    start: window.innerHeight + ' top',
    end: document.body.clientHeight,
    scroller: smooth.scroller,
    scrub: 'none',
    onEnter: () => { gsap.to('#hd-nav',{y: 0}); },
    onEnterBack: () => { gsap.to('#hd-nav',{y: 0}); },
    onLeave: () => { gsap.to('#hd-nav',{y: '-100%'}); },
    onLeaveBack: () => { gsap.to('#hd-nav',{y: '-100%'}); },
  });

  // houes
  const time = document.getElementById('scroll-hours');
  time.addEventListener('click',() => {
    time.classList.toggle('is-active');
  });
  document.body.addEventListener('click',(e) => {
    const time = document.getElementById('scroll-hours');
    const clickedElement = event.target;
    if (time && time.classList.contains('is-active') && !time.contains(clickedElement)) {
      time.classList.remove('is-active');
    }
  });
  ScrollTrigger.create({
    trigger: '#mainimg',
    target: '#scroll-hours',
    start: window.innerHeight + ' top',
    end: document.body.clientHeight,
    scroller: smooth.scroller,
    scrub: 'none',
    onEnter: () => { gsap.to('#scroll-hours',{opacity: 1, filter: 'bluer(0)'}); },
    onEnterBack: () => { gsap.to('#scroll-hours',{opacity: 1, filter: 'bluer(0)'}); },
    onLeave: () => { gsap.to('#scroll-hours',{opacity: 0, filter: 'bluer(10px)'}); },
    onLeaveBack: () => { gsap.to('#scroll-hours',{opacity: 0, filter: 'bluer(10px)'}); },
  });
  
  /*----------------------------------------
    animations
  ------------------------------------------*/
  const FadeIn   = (elements) => { gsap.to(elements, { opacity: 1, duration: .5, x: 0, stagger: 0.15, filter: "blur(0)" }); }
  const FadeOut  = (elements) => { gsap.to(elements, { opacity: 0, x: 30, stagger: 0.15, filter: "blur(10px)" }); }
  gsap.set(".is-animation >*", { opacity: 0, x: 30, filter: "blur(10px)" });
  ScrollTrigger.batch(".is-animation >*", {
    scroller: smooth.scroller,
    scrub: 0,
    start: 'top 80%',
    onEnter    : (elements, triggers) => { FadeIn(elements) },
    onEnterBack: (elements, triggers) => { FadeIn(elements) },
    onLeave    : (elements, triggers) => { FadeOut(elements) },
    onLeaveBack: (elements, triggers) => { FadeOut(elements) },
  });

  // is-split
  const TextIn   = (elements) => { gsap.to(elements, { opacity: 1, x: 0, y: 0, duration: .2, stagger: 0.05 ,filter: "blur(0)" }); }
  gsap.set(".is-split >*", { opacity: 0, x: 10, y: 10 , filter: "blur(10px)" });
  ScrollTrigger.batch(".is-split >*", {
    scroller: smooth.scroller,
    scrub: 0,
    start: 'top 70%',
    onEnter    : (elements, triggers) => { TextIn(elements) },
  });

  /*----------------------------------------
    add class
  ------------------------------------------*/
  gsap.utils.toArray(".is-add").forEach((target) => {
    ScrollTrigger.create({
      trigger: target,
      scroller: smooth.scroller,
      scrub: 0,
      start: 'top 80%',
      toggleClass: "is-active"
    });
  });

  /*----------------------------------------
    default settings
  ------------------------------------------*/
  new HamburgerMenu('hamburger', 'hd-nav', 'is-active');
  modalImage();
  new ShaderCanvas();
  scrollHint('.is-hint');
});
